

import React, { Component } from 'react';
import * as ReactDOM from 'react-dom';
import axios from 'axios';
import Company from './Company';
import Advartise from './Advartise';
import Configdata from './Defaultdata';

import userp from './imgs/profileuser.png';
import { add, multiply,imgb64,chekf,dfltpic } from './utility';
import Approval from './Approval';
import Rejects from './Rejects';
import proflimg from './profiles/profilephoto.png';
import Register from './Register';
import Usermsg from './Usermsg';
import Changepassword from './Changepassword';
import { getmessage,getutypebyid,setuserpoints } from './Dynamictable';
import { getprofileoffer } from './userdefaultdata';
import Viewposts from './Viewposts';
import Offers from './Offers';
import Viewphones from './Viewphones';
import Viewsalesapply from './Viewsalesapply';
import Paymentgetway from './Paymentgetway';
import {clearmain,clearprofile} from './clearmem';
import imgout from './imgs/logout.png';
import {isvaliduser} from './validation';
class Profile extends Component {
	constructor(props: any) {
   	super(props);
	this.state.toggleprofile = false;
	this.state.imgprofilestr = "";
    	this.toggeluserprofile = this.toggeluserprofile.bind(this);
	
  	}
	state = {
        name: "",
        toggleprofile: false,
        imgprofilestr:"",
	tmpimgprofilestr:"",
	email:"",
	phone:"",
	points:"",
	utype:"",
	offers:"",
	code:"",
	profiledata:{utype:0,username:"",uemail:"",userpoints:0,uofferid:0},
	iscaches: true
    	};
	messageshow(e: any){
	//alert('ok');
	}
        flashconnecttest(e: any){
	axios
            .get("http://localhost:5000/appusers")
            .then((response: any) => {
               // alert(response.data);
               
            })
            .catch((err: any) => {
               // alert('Something went wrong');
                
            });
	
	}
      
        pfpupload(e: any){
               const selectedFile = e.target.files[0];
               const ftpe = chekf(selectedFile);
               
               if(ftpe == 'png' || ftpe == 'jpeg'){
	       var base64String ="";
               imgb64(selectedFile).then((result:any) => {
	        base64String = result;
		//var bs64 = base64String.replace(/^data:image\/[a-z]+;base64,/, '');
                                
                this.insertprofilephoto(ftpe,base64String); 
               // this.setState({ tmpimgprofilestr: base64String });
		
    		}).catch(err => {
        	  
    		});
	       }
	       else{
 		getmessage('Please upload png or jpg file','');
	        }
	       			
          
	}
	showimgstring(dt: any){
		
		//alert(dt);
	}
	getpfpphoto(e: any){
		const el = document.getElementById("pfpphoto");
        	if(el)
        	el.click();
                
	}

	insertprofilephoto(ftyp: any,bstr: any){
        
	
         
	//alert(Configdata.srvurl + '/insertprofilephoto');
		
        try {
		const response = axios.post(Configdata.srvurl + '/insertprofilephoto', {
    		id: '23',
    		fpath: 'AIB',
    		fextn: ftyp,
                bsimg: bstr,
		upin:localStorage.getItem("id")
  		}, {
    		    headers: {
      				'Content-Type': 'application/json'
    			      }
  			}
		);
		
		if(response){
		 response.then((result:any) => {
                // const tmpbase64String = this.state.tmpimgprofilestr;
		//alert(bstr);
		this.setState({ imgprofilestr: bstr });
		localStorage.setItem("profeimg",bstr);
	        });		
              }
          
           // alert('Saved successfully');
          
        }
        catch (e) {
             //  alert('error');
        }

	}

        setprofilephoto(e: any){
	

		const id = localStorage.getItem("id");
                const usercode = 'AIBN0010';
		const photopath = usercode; 
        	const requestOptions = {
            		method: 'POST',
            		headers: { 'Content-Type': 'application/json' },
            		body: JSON.stringify({uid: id,paths: photopath })
        };
        try {
            const promiseAwait = fetch(Configdata.srvurl + '/insertprofilephoto', requestOptions);
            getmessage('Saved successfully','');
          
        }
        catch (e) {
            debugger;

           // alert('error');
        }

	}
	toggeluserprofile(){
		

		const chkpvisible = this.state.toggleprofile == false ? true: false;
		this.setState({ toggleprofile: chkpvisible });
		const userprofile = document.getElementById('profilediv') as HTMLElement;
		//const userprofileimg = document.getElementById('profilephoto') as HTMLInputElement;

		const profilename = document.getElementById('profileusername') as HTMLElement;
		
 
		//profilename.innerHTML = "Amelia D'Sluza";

		

		
	};
	
	showcompany(e: any){
		
		 try {
		
		const compny = <Company />
             
                var maindiv = document.getElementById('container') as HTMLElement;
		const Pdivr = document.getElementById('profilediv') as HTMLElement;
		ReactDOM.render(compny,maindiv);
		maindiv.style.display = 'block';
		Pdivr.style.display = 'none';
	   	}
	    	catch(e){
		
	        }	
	
	   	e.preventDefault()	
		
	};
showphones(e: any){
		
		 try {
		
		const phones = <Viewphones />
             
                var maindiv = document.getElementById('container') as HTMLElement;
		const Pdivr = document.getElementById('profilediv') as HTMLElement;
		ReactDOM.render(phones,maindiv);
		maindiv.style.display = 'block';
		Pdivr.style.display = 'none';
	   	}
	    	catch(e){
		
	        }	
	
	   	e.preventDefault()	
		
	};
	showapprove(e: any){
		
		 try {
		clearmain();
		const approve = <Approval />
             
                var maindiv = document.getElementById('container') as HTMLElement;
		const Pdivr = document.getElementById('profilediv') as HTMLElement;

		ReactDOM.render(approve,maindiv);
		maindiv.style.display = 'block';
		Pdivr.style.display = 'none';
	   	}
	    	catch(e){
		
	        }	
	
	   	e.preventDefault()	
		
	};
	showreject(e: any){
		
		 try {
		clearmain();
		const reject = <Rejects />
             
                var maindiv = document.getElementById('container') as HTMLElement;
		const Pdivr = document.getElementById('profilediv') as HTMLElement;
		ReactDOM.render(reject,maindiv);
		maindiv.style.display = 'block';
		Pdivr.style.display = 'none';
	   	}
	    	catch(e){
		
	        }	
	
	   	e.preventDefault()	
		
	};
showsales(e: any){
		
		 try {
		clearmain();
		const sale = <Viewsalesapply />
             
                var maindiv = document.getElementById('container') as HTMLElement;
		const Pdivr = document.getElementById('profilediv') as HTMLElement;
		ReactDOM.render(sale,maindiv);
		maindiv.style.display = 'block';
		Pdivr.style.display = 'none';
	   	}
	    	catch(e){
		
	        }	
	
	   	e.preventDefault()	
		
	};
	
	adventry(e: any){
		
		 try {
		
		const compny = <Advartise />
             
                var maindiv = document.getElementById('container') as HTMLElement;
		const Pdivr = document.getElementById('profilediv') as HTMLElement;
		ReactDOM.render(compny,maindiv);
		maindiv.style.display = 'block';
		Pdivr.style.display = 'none';
	   	}
	    	catch(e){
		
	        }	
	
	   	e.preventDefault()	
		
	};

	componentDidMount() {
        //debugger;
        let isCacheSupported = 'caches' in window;
	if(!isCacheSupported) this.setState({ iscaches: false });
	this.displayofficial('none');
     	this.toggeluserprofile();
        if(isvaliduser()){
	this.userinfosettings(true);
	//this.setState({ imgprofilestr: dfltpic });
	
	// this.setprofiledata();
        }
		
    	}
        
	userinfosettings(uinfo: any){
        if(uinfo){
	let objuserstr = "";
	//alert(uinfo.uemail);	
	 
       
	
       // const ut = getutypebyid(uinfo.utype);
	 
	  //this.setState({ name: uinfo.username });
	  const user = uinfo.username;
	  //this.setState({ email: uinfo.uemail });
	 // this.setState({ utype: ut });
	 // this.setState({ points: uinfo.userpoints });
	 
	 // const offrid =  uinfo.uofferid; 	
         // const offername = getprofileoffer(offrid);
           
	 //  this.setState({ offers: offername});
	
	   this.setpfp();
         const userinf = localStorage.getItem("userinfo");
	 if(userinf){
	  
          objuserstr = userinf.toString();
          const userinfjson = JSON.parse(objuserstr);
	  const usercode = userinfjson.id;
	
	  this.setState({ code: usercode });
	  this.setState({ name: userinfjson.uname });
	   this.setState({ email: userinfjson.mailid });
	   //const ut = getutypebyid(userinfjson.utype);	
	 	this.setState({ utype: userinfjson.utype });
		
	    this.setState({ points: userinfjson.upoints });
	
	  const offrid =  userinfjson.offer; 	
          const offername = getprofileoffer(offrid);
           
	   this.setState({ offers: offername});
           this.displayofficial(userinfjson.utype.toString());		

	  }	
        	
	
	}	
       }
       displayofficial(utp: any){
		var offcialdv = document.getElementById('ofcaproval') as HTMLElement;
		
		if(utp == "Admin" || utp == "Official"){
			 offcialdv.style.display = 'block';
				
		}
		else{
		 offcialdv.style.display = 'none';
		}

	}
       setpfp(){

	const imgbs64 = localStorage.getItem("profeimg");
	let limg = false;
	   if(imgbs64){
		
		const strpfp = imgbs64.toString();
		if(strpfp.length > 4) this.setState({ imgprofilestr: imgbs64 });
		else this.setprofilephotodata();
	     
		
	   }
	   else{
		
	  	this.setprofilephotodata();
	  }
	}
	
	logout(e: any){
	 this.setState({ email: "" });
	  this.setState({ utype: "" });
	  this.setState({ points: "" });
	  this.setState({ name: "" });	
	  this.setState({ offers: "" });
	  localStorage.setItem("profeimg","NA");
	  //localStorage.removeItem("userinfo");
	 localStorage.setItem("userinfo","NA");
	  localStorage.setItem("id","NA");
	  this.showshinin();
	e.preventDefault();
	}
       showshinin(){
	         const elesrch = <Register />
		const Pdcivr = document.getElementById('profilediv') as HTMLElement;
		ReactDOM.render(elesrch,Pdcivr);

	}
        changeuserpasswrd(e: any){
                const changepswd = <Changepassword />

		const Pdivr = document.getElementById('profilediv') as HTMLElement;
		ReactDOM.render(changepswd,Pdivr);
	   e.preventDefault();
	}
        profilemessages(e: any){
		clearmain();
		const posts = <Usermsg />
		 var maindiv = document.getElementById('container') as HTMLElement;
		const Pdivr = document.getElementById('profilediv') as HTMLElement;
		ReactDOM.render(posts,maindiv);
		maindiv.style.display = 'block';
		Pdivr.style.display = 'none';
		
		e.preventDefault();
	}
	profileoffers(e: any){
		const offr = this.state.offers;
		this.loadoffers();
		//getmessage(offr,'');

		e.preventDefault();
	}
	profileposts(e: any){
	         const posts = <Viewposts />
		 var maindiv = document.getElementById('container') as HTMLElement;
		const Pdivr = document.getElementById('profilediv') as HTMLElement;
		ReactDOM.render(posts,maindiv);
		maindiv.style.display = 'block';
		Pdivr.style.display = 'none';
		
		e.preventDefault();
	}
	profileother(e: any){
		getmessage('You have no other activity','');
		e.preventDefault();
	}
        iniciatepayment(e:any){
               const posts = <Paymentgetway />
		var maindiv = document.getElementById('customemsgdiv') as HTMLElement;
		const Pdivr = document.getElementById('profilediv') as HTMLElement;
		ReactDOM.render(posts,maindiv);
		maindiv.style.display = 'block';
		Pdivr.style.display = 'none';

	e.preventDefault();

        }
     

	setprofilephotodata(){
	 try {
            const pid = '23';
		//alert(localStorage.getItem("id"));
	        const response = axios.post(Configdata.srvurl + '/getpfpphoto', {
    		upin: localStorage.getItem("id"),
		userid:30
    		
  		}, {
    		    headers: {
      				'Content-Type': 'application/json'
    			      }
  			}
		);
	      
                if(response){
		 response.then((result:any) => {
		const strimg = result.data;
		//alert(strimg);
		if(strimg != 'NA'){
		localStorage.setItem("profeimg",strimg)
		this.setState({ imgprofilestr: strimg });
		}
		
		
	        });		
              }
		
    	 }
     	 catch (e) {
           // debugger;

     	 }


	}
	setprofiledata(){
 	try {
        const upin = localStorage.getItem("id");
 	
	axios.get(Configdata.srvurl + '/getuserinfo?'+'prd='+ upin)
            .then((response: any) => {
               
		const tdata = response.data;
            
		this.reduceuserinfo(tdata);
            })
            .catch((err: any) => {
               // alert('Something went wrong');
               
            });

                
          }
        catch (e) {
           // debugger;

        }

 }
setuserprofileinfo(pdta:any){
	if(pdta){
		
		this.setState({ profiledata: pdta});
		this.userinfosettings(pdta);
		//alert(this.state.profiledata.uemail);
	}
}
 reduceuserinfo(arr: any){
     let farr = {};
      if(arr)
	 if(arr.length > 0) farr = arr[0][0];
	this.setuserprofileinfo(farr);
     
 }	


loadoffers(){
		
	       
		const elesrch = <Offers />
		const Pdcivr = document.getElementById('container') as HTMLElement;

                const Pdivr = document.getElementById('profilediv') as HTMLElement;
		
		ReactDOM.render(elesrch,Pdcivr);
		Pdcivr.style.display = 'block';
		Pdivr.style.display = 'none';

		
		


		
	};

	render() {
		return (
		<form>
		<div id="profilesidebardiv" className="sidebar-search">

		     <div className="search-title-bar">
                       	<div className="search-title">
			  Profile
			</div>
			<a href="#" onClick={e => this.messageshow(e)} title="Profile">
			<div className="search-title-toggle" id="togglesearch">
			  +
			</div>
			</a>
	   	     </div>
		     <div className="sidebar-basic-info">
			
                       	<div className="sidebar-inner-left" id="profilephoto">
					
			  	<span className="imagespan">
				<a href="#" onClick={e => this.getpfpphoto(e)} >
				<img className="profile-photo" id="profilephoto" style={{position:'relative',top:'-9px'}} src={this.state.imgprofilestr} />
				</a>	
				</span>
			 	
				<span className="usertypespan" id="profileusertype">
					{this.state.utype}
				</span>
			</div>
			
			<div className="sidebar-inner-right">
			  	<div className="profile-username" id="profileusername">
					{this.state.name}
				</div>
				
				<div className="profile-username" id="profileusername">
					<button onClick={e=>this.changeuserpasswrd(e)} id="changepassword">Change Password</button>
				</div>
				<div className="profile-username">
					<span id="profilemail">{this.state.email}</span>
				<a href="#" className="verifyprofile" style={{color:'red',display:'none'}}  id="veryfymail"><span>Not verify</span></a>
				</div>
	
		
			</div>
	
			
	   	     
		    
		    <div className="sidebar-profile-details">
			<div className="sidebar-inner-right">

		      		
				<div className="profile-usermail"  style={{display:'none'}}>
					<span  id="profileusertype">xxxxxxxxxx</span>
				<a href="#"  className="verifyprofile" style={{color:'green'}} id="veryfymail"><span>verified</span></a>

				</div>
				
			</div>
		     </div>

	        </div>
		<div className="sidebar-basic-info">
		<div className="profile-item-row" style={{ marginBottom:'10px'}}>
		     <div style={{width:'10vw',float:'left'}}>
		       <ul className="ulnobullet" style={{padding:'0px',color:'#ffffff'}}>
			  <li> Points</li>
		          <li>{this.state.points}</li>	
                          <a onClick={e =>this.iniciatepayment(e)} href="#">
			   <li> Add points</li>
                          </a>

			</ul>
		     </div>	
	             <div style={{width:'55vw',float:'right',}}>
		       <div className="profile-item-row">
			<a href="#" onClick={e=>this.profileposts(e)} className="profile-items">Posts</a>
		      	<a href="#" onClick={e=>this.profilemessages(e)} className="profile-items">Messages</a>
			
		       </div>
		        <div className="profile-item-row">
			<a href="#" onClick={e=>this.profileoffers(e)} className="profile-items">Offers</a>
			<a href="#" onClick={e=>this.profileother(e)} className="profile-items">Other</a>
			
		        </div>	
			<div id="ofcaproval"  className="profile-item-row">
			
			<a href="#" onClick={e=> this.showapprove(e)} className="profile-items">Aprove</a>
			<a href="#"  onClick={e=> this.showreject(e)} className="profile-items" style={{display:'none'}}>Rejct</a>
			<a href="#"  onClick={e=> this.showsales(e)} className="profile-items">Sales</a>

			<a href="#"  onClick={e=> this.showphones(e)} className="profile-items">Ph</a>
			
		        </div>	
			<div id="logout"  className="profile-item-row">
			<a href="#" onClick={e =>this.logout(e)} className="profile-items">{this.state.code}<img id="img_logout" 				style={{width:'20px',height:'20px',marginTop:'5px'}} src={imgout} /></a>
		        </div>	
		     </div>
		     <div className="sidebar-profile-details">
		      
		     </div>	
		  </div>
		
 		 <div className="profile-item-row" id="ofcaproval1" style={{display:'none'}}>  
	            
		   <div className="sidebar-profile-details">
		      <div className="sidebar-inner-right">
			<a href="#" onClick={e=> this.showapprove(e)} className="profile-items" style={{marginLeft:'20px'}}>Aprv</a>
			<a href="#"  onClick={e=> this.showreject(e)} className="profile-items">Rej</a>
			
			
		       </div>
		     </div>
		 </div>  


		  <div className="profile-item-row">  
	             <div className="sidebar-profile-details" style={{display:'none'}}>
		      <div className="sidebar-inner-right">
			
			
			<a href="#" className="profile-items">Chat</a>
			<a href="#" className="profile-items">Edit Profile</a>
		       </div>
		     </div>

		   <div className="sidebar-profile-details" style={{display:'none'}}>
		      <div className="sidebar-inner-right">
			<a href="#" onClick={e=> this.showcompany(e)} className="profile-items">Companies</a>
			<a href="#"  onClick={e=> this.adventry(e)} className="profile-items">Advatise</a>
			
		       </div>
		     </div>
		 </div>  
		
	    </div>
	   <div className="sidebar-basic-info">
		<div className="profile-item-row">	
	             <div style={{display:'none'}}>
			 <input type="file" id="pfpphoto" onChange={e => this.pfpupload(e)} />
		     </div>
	
	    </div>
	    </div>	        

  </div>

 </form>
 );
}
	
}

export default Profile;
